import { render, staticRenderFns } from "./LandingGift.vue?vue&type=template&id=859dddf4&scoped=true"
import script from "./LandingGift.vue?vue&type=script&lang=js"
export * from "./LandingGift.vue?vue&type=script&lang=js"
import style0 from "./LandingGift.vue?vue&type=style&index=0&id=859dddf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859dddf4",
  null
  
)

export default component.exports